export const getFooterInfo = (state) => state.stylesReducer.footerInfo;
export const getCookieBannerInfo = (state) => state.stylesReducer.cookieBannerInfo;
